import {Permission} from '../CustomComponents'
import {ID} from '../../_metronic/helpers'
import {DeleteModal} from './DeleteModal'
import {useState} from 'react'

type Props = {
  clearSelected: () => void
  selected: ID[]
  action: (ids: ID) => Promise<void>
  refetch?: () => void
}

export const ListGrouping = (props: Props) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  return (
    <>
      <div className='flex items-center justify-end space-x-4'>
        <div className='font-semibold text-gray-700'>
          <span className='mr-1'>{props.selected.length}</span> Selected
        </div>

        <Permission permission='is_delete'>
          <button
            type='button'
            className='px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-md'
            onClick={() => setShowDeleteConfirm(true)}
          >
            Delete Selected
          </button>
        </Permission>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteModal
        showDeleteConfirm={showDeleteConfirm}
        setShowDeleteConfirm={setShowDeleteConfirm}
        deleteAction={props.action}
        refetch={() => {
          if (props.refetch) props.refetch()
          props.clearSelected()
        }}
        id={props.selected.join(',')}
      />
    </>
  )
}
